export default __webpack_public_path__ + "static/CopiersPrinter-67e3c0c31934454b082a38bef7fbf978.jpeg";